import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-048243c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-logo-pages" }
const _hoisted_2 = { class: "logo-icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-text" }, "争芳后台", -1))

import { reactive } from "vue";

/** 图片 */

export default /*#__PURE__*/_defineComponent({
  __name: 'inde',
  setup(__props) {

const logoIcon = reactive({
  logoIcon: require("../../_static/logo.png")
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: logoIcon.logoIcon,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4
  ]))
}
}

})